/** Returns a pretty decimal string from the given number. E.g. `1042.991` -> `1,042.99` with decimalPlaces === 2 */
export const decimalPrettifier = (
  input: number | undefined,
  decimalPlaces: number | {min: number; max: number},
  leadingZero: boolean
): string => {
  if (input === undefined || isNaN(input)) {
    return ''
  }

  if (typeof Intl === 'undefined') {
    // do our best for this very old browser.
    return `${decimalPlaces === 0 ? Math.trunc(input) : input}`
  }

  let min, max: number
  if (typeof decimalPlaces === 'number') {
    min = decimalPlaces
    max = decimalPlaces
  } else {
    min = decimalPlaces.min
    max = decimalPlaces.max
  }

  const options = {
    minimumFractionDigits: min,
    maximumFractionDigits: max,
  }

  const formatter = new Intl.NumberFormat('en-US', options)
  let retVal = formatter.format(input)
  if (!leadingZero) {
    retVal = retVal.replace(/^([+-]?)0+(?=.)/, '$1')
  }
  // use the 'correct' minus sign. it's longer than a hyphen, I swear.
  retVal = retVal.replace('-', '−')

  if (retVal.match(/^−(0(?:\.0+)?$)/)) {
    // remove the leading negative sign if the number equals 0
    return retVal.slice(1)
  }

  return retVal
}
